import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import OrderDetails from "./views/OrderDetails";
import DeliveryList from "./views/DeliveryList";
import DeliveryInfoPanel from "./panels/DeliveryInfoPanel";
import DeliveryLogPanel from "./panels/DeliveryLogPanel";
import ShippingInfoPanel from "../shipping/panels/ShippingInfoPanel";
import ShippingStatusPanel from "../shipping/panels/ShippingStatusPanel";
import {getAllShopsWithAllOption} from "../lib/Shops";
import {getAllWarehouses, filterCourier, addAllWarehousesOption} from "../lib/Warehouses";
import gql from "graphql-tag";
import {withApollo} from "react-apollo";
import {List, fromJS} from "immutable";

const statusFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "idle", label: "Idle"},
  {id: "processed", label: "Processed"},
  {id: "in_transit", label: "In Transit"},
  {id: "completed", label: "Completed"}
])

const dateFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "current_week", label: "This week"},
  {id: "next_week", label: "Next week"},
  {id: "future", label: "Future"}
])

class UpcomingSubscriptionsPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleDeliveryIdClick = this.handleDeliveryIdClick.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      deliveryId: "",
      hasDeliverySelection: false,
      selectedPanelId: "general",
      shopFilter: "",
      statusFilter: "",
      dateFilter: "current_week",
      warehouseFilter: "",
      distributionFilter: "",
    }
  }

  componentDidMount() {
    if (this.props.route.page === "subscription") {
      this.setState({deliveryId: this.props.params.deliveryId});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.params.deliveryId !== this.props.params.deliveryId) {
      this.setState({deliveryId: this.props.params.deliveryId})
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Upcoming Subscriptions / Deliveries";
    if (page === "subscription") {
      title = `${title} / ${this.state.deliveryId}`;
    }

    return (
      <div className="SalesPage SubscriptionsPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "subscription"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={true} label="Filter" id="general" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasDeliverySelection} label="Properties" id="properties" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={this.state.hasDeliverySelection} label="Log" id="log" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={false} label="Shipping" id="shipping" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Manually Start Delivery" 
              active={this.state.hasDeliverySelection}
              onClick={this.handleStartDelivery.bind(this)} />          
            <ActionButton 
              label="Retry Stock Reservation" 
              active={this.state.hasDeliverySelection}
              onClick={this.handleRetryStockReservation.bind(this)} />    
            <ActionButton 
              label="Change Stock Reservation Warehouse" 
              active={this.state.hasDeliverySelection}
              onClick={this.handleChangeStockReservationWarehouse.bind(this)} />                    
            <ActionButton 
              label="Retry Scheduling" 
              active={this.state.hasDeliverySelection}
              onClick={this.handleRetryScheduling.bind(this)} />          
          </PanelGroupController>
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "subscriptions":
        return (
          <DeliveryList 
            selectedId={this.state.deliveryId} 
            onSelectionChange={this.handleSetSelection}
            onIdClick={this.handleDeliveryIdClick}
            shopFilter={this.state.shopFilter}
            statusFilter={this.state.statusFilter}
            dateFilter={this.state.dateFilter}
            warehouseFilter={this.state.warehouseFilter}
            distributionFilter={this.state.distributionFilter}
            />
        )
      case "subscription":
        return (
          <OrderDetails
            deliveryId={this.state.deliveryId}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "subscriptions":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([DeliveryInfoPanel]));
        } else if (this.state.selectedPanelId === "log") {
          return this.buildPanels(List([DeliveryLogPanel]));
        } else if (this.state.selectedPanelId === "general") {
          return this.buildPanels(List(["shopFilter", "statusFilter", "dateFilter", "warehouseFilter", "distributionFilter"]));
        } 
        break;
      case "subscription":
        if (this.state.selectedPanelId === "properties") {
          return this.buildPanels(List([DeliveryInfoPanel]));
        }
        break;
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case "shopFilter":
        return <FilterPanel
          key="ShopFilterPanel"
          title="Shop Filter"
          expanded={false}
          options={getAllShopsWithAllOption()}
          onClick={this.handleSetShopFilter.bind(this)}
          filter={this.state.shopFilter}
          />      

      case "statusFilter":
        return <FilterPanel
          key="StatusFilterPanel"
          title="Status Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={this.handleSetStatusFilter.bind(this)}
          filter={this.state.statusFilter}
          />        

      case "dateFilter":
        return <FilterPanel
          key="TimeFilterPanel"
          title="Time Filter"
          expanded={true}
          options={dateFilterOptions}
          onClick={this.handleSetDateFilter.bind(this)}
          filter={this.state.dateFilter}
          />        

      case "warehouseFilter":
        let distributionWarehouses = getAllWarehouses();
        distributionWarehouses = filterCourier(distributionWarehouses);
        distributionWarehouses = addAllWarehousesOption(distributionWarehouses);

        return <FilterPanel
          key="WarehouseFilterPanel"
          title="Warehouse Filter"
          expanded={false}
          options={distributionWarehouses}
          onClick={this.handleSetWarehouseFilter.bind(this)}
          filter={this.state.warehouseFilter}
          />        

      case "distributionFilter":
        let warehouses = getAllWarehouses();
        warehouses = filterCourier(warehouses);
        warehouses = addAllWarehousesOption(warehouses, "Don't Apply");
        return <FilterPanel
          key="DistributionFilterPanel"
          title="Distribution Filter"
          expanded={false}
          options={warehouses}
          onClick={this.handleSetDistributionFilter.bind(this)}
          filter={this.state.distributionFilter}
          />        

      case DeliveryInfoPanel:
        if (!this.state.hasDeliverySelection) return null;
        return <DeliveryInfoPanel key="DeliveryInfoPanel" deliveryId={this.state.deliveryId} />

      case DeliveryLogPanel:
        if (!this.state.hasDeliverySelection) return null;
        return <DeliveryLogPanel key="DeliveryLogPanel" deliveryId={this.state.deliveryId} />

      case ShippingStatusPanel:
        return <ShippingStatusPanel key="ShippingStatusPanel" deliveryId={this.getOrderShippingId(this.state.deliveryId)} />

      case ShippingInfoPanel:
        return <ShippingInfoPanel 
                  key="ShippingInfoPanel" 
                  deliveryId={this.getOrderShippingId(this.state.deliveryId)} 
                  title="Shipping Order Info" />

      default:
        return null;      
    }
  } 

  getOrderShippingId() {
    const result = this.props.client.readFragment({
      id: `subscription-delivery:${this.state.deliveryId}`,
      fragment: gql`
        fragment myFrag on SubscriptionDelivery {
          shippingOrderId
        }
      `
    });    
    console.log("Result", result);      
    return result.shippingOrderId;
  }

  handleSetShopFilter(item) {
    this.setState({
      shopFilter: item.get("id")
    });
  }     

  handleSetStatusFilter(item) {
    this.setState({
      statusFilter: item.get("id")
    });
  }     

  handleSetDateFilter(item) {
    this.setState({
      dateFilter: item.get("id")
    });
  }     

  handleSetWarehouseFilter(item) {
    this.setState({
      warehouseFilter: item.get("id")
    });
  }     

  handleSetDistributionFilter(item) {
    this.setState({
      distributionFilter: item.get("id")
    });
  }     

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }  

  handleSetSelection(id) {
    this.setState({deliveryId: id, hasDeliverySelection: true, selectedPanelId: "properties"});
  }

  handleDeliveryIdClick(id, accountId) {
    this.props.router.push(`/accounts/${accountId}`);    
  }

  handleBack() {
    // this.props.router.push(`/sales/orders`);
  }  

  handleStartDelivery() {
    this.props.requestStartDelivery(this.state.deliveryId);
  }

  handleRetryScheduling() {
    this.props.requestRetryScheduling(this.state.deliveryId);
  }

  handleRetryStockReservation() {
    this.props.requestRetryStockReservation(this.state.deliveryId);
  }

  handleChangeStockReservationWarehouse() {
    this.props.requestChangeStockReservationWarehouse(this.state.deliveryId);
  }  

}

export default withApollo(UpcomingSubscriptionsPage);